import React, {useContext, useEffect} from 'react';
import Plot from 'react-plotly.js';
import Classes from './dashboard.module.css';
import {
  EachPageHeader,
  PageHeader,
} from '../../component/layout/eachPageHeader/eachPageHeader';
import {Helmet} from 'react-helmet';
import Sidebar from '../../component/layout/sidebar/sidebar';
import {MainContext} from '../../App';
import DashboardCard from '../../component/dashboardCard/dashboardCard';
import {ReactComponent as Money} from '../../asset/money.svg';
import {ReactComponent as Store} from '../../asset/store.svg';
import {ReactComponent as Box} from '../../asset/box.svg';
import {ReactComponent as Bag} from '../../asset/bag.svg';
import RecentOrder from './recentOrder';
import { GetUserStatistics } from '../../helper/getUserStatistics';
//

const Home = () => {
  const CTX = useContext(MainContext);

  const {data, getSta} = GetUserStatistics();

  useEffect(() => {
    const sad = getSta()
    if(data.balance){
      // CTX.setStats(data)
    }
  }, [])
  
  console.log("data => ", data )

  return (
    <div className={Classes.flexSection}>
      <Helmet>
        <title>Overview - Passward Vendor </title>
        <meta name="og:title" content="Overview - Passward Vendor" />
        <meta name="og:description" content="Settings - Passward Vendor" />
        <meta
          name="og:name"
          content="Passward is Nigeria's No.1 Online Shopping Destination with the largest collection of electronics, smartphones, groceries, computers, fashion, jewelry & more. ✓ Top brands at the best prices ✓ Enjoy cash on delivery on eligible purchases."
        />
        <meta
          name="og:name"
          content="Passward is Nigeria's No.1 Online Shopping Destination with the largest collection of electronics, smartphones, groceries, computers, fashion, jewelry & more. ✓ Top brands at the best prices ✓ Enjoy cash on delivery on eligible purchases."
        />
      </Helmet>
      <Sidebar />
      <div
        onClick={CTX.removeSideBar}
        style={{
          padding: '0px 20px',
          boxSizing: 'border-box',
          width: '100%',
          filter: 'blur(var(--body-blur,0px))',
        }}
      >
        <EachPageHeader first="Home" second="Account" third="Overview" />
        <PageHeader name="Overview" />
        <div className={Classes.gridDashboardCard}>
          <DashboardCard label="Total Revenue" num={"₦ " + data?.overview?.revenue} svg={<Money />} />
          <DashboardCard label="Orders" num={data?.overview?.order} svg={<Bag />} />
          <DashboardCard label="Products" num={data?.overview?.product} svg={<Store />} />
          <DashboardCard label="Customers" num={data?.overview?.customer} svg={<Box width="18px" />} />
        </div>

        <div className={Classes.firstGraph}>
          <div className={Classes.headerSection}>
            <strong>Wallet Balance</strong>
            <select>
              <option>2022</option>
              <option>2022</option>
              <option>2022</option>
              <option>2022</option>
            </select>
          </div>
          <Plot
            data={[
              {
                x: [1, 2, 3],
                y: [2, 6, 3],
                mode: 'lines',
                marker: {color: '#969696'},
              },
            ]}
            className={Classes.theSVG}
            style={{width: '100%', height: '100%'}}
            layout={{
              responsive: true,
              useResizeHandler: true,
              autosize: true,
              title: '',
              xaxis: {
                showgrid: true,
              },
              yaxis: {
                showgrid: true,
                autotick: false,
                ticks: 'outside',
                tick0: 0,
                // dtick: 1.25,
                ticklen: 28,
                tickwidth: 4,
                tickcolor: '#e9eaf9',
              },
            }}
            config={{displayModeBar: false}}
          />
        </div>

        <div className={Classes.firstGraph}>
          <div className={Classes.headerSection}>
            <strong>My Orders</strong>
            <select style={{width: '100px'}}>
              <option>February</option>
              <option>March</option>
              <option>April</option>
              <option>May</option>
            </select>
          </div>
          <Plot
            data={[
              {
                x: [1, 2, 3],
                y: [4, 5, 8],
                mode: 'lines',
                marker: {color: '#969696'},
              },
            ]}
            className={Classes.theSVG}
            style={{width: '100%', height: '100%'}}
            layout={{
              responsive: true,
              useResizeHandler: true,
              autosize: true,
              title: '',
              xaxis: {
                showgrid: true,
              },
              yaxis: {
                showgrid: true,
                autotick: false,
                ticks: 'outside',
                tick0: 0,
                // dtick: 1.25,
                ticklen: 28,
                tickwidth: 4,
                tickcolor: '#e9eaf9',
              },
            }}
            config={{displayModeBar: false}}
          />
        </div>
        <RecentOrder />
      </div>
    </div>
  );
};

export default Home;
